import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { landingSchemas, pageHead } from "@/lib/seo";

const page = landingPages["fractional-cmo-france"];
if (!page) throw new Error("Missing Fractional CMO France guide content");

export const Route = createFileRoute("/fractional-cmo-france")({
  head: () => pageHead({
    path: page.path,
    title: page.fr.title,
    description: page.fr.description,
    enPath: null,
    crumbs: [["Services", "/services"], ["Fractional CMO France", page.path]],
    schemas: landingSchemas(page.fr),
  }),
  component: () => <LandingPage pageKey="fractional-cmo-france" forceLanguage="fr" />,
});